// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menu-upload[data-v-082a0390]{background-color:#f4f4f4;height:100%}.menu-upload .bulk-upload-component-wrapper[data-v-082a0390]{min-height:80vh}.dotted-border[data-v-082a0390]{border:1px dashed #adadad;border-radius:8px;min-height:600px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
